import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { generateGuid } from 'utils/guid';
import z from 'zod';
import { DisabledDiscoveryTasks } from '../components/DisabledDiscoveryTasks/DisabledDiscoveryTasks';
import {
  type DiscoveryTasksRowData,
  discoveryTasksRowDataSchema,
} from '../components/DisabledDiscoveryTasks/DiscoveryTasksRowData';
import type { DiscoverySettingsObject } from '../model/DiscoverySettingsObject';

type DisabledDiscoveryTasksFieldValues = {
  disabledDiscoveryTasks: DiscoveryTasksRowData[];
};

const emptyStrToNull = (str: string) => (str === '' ? null : str);

export const disabledDiscoveryTasks: FormSnippet<
  DiscoverySettingsObject,
  DisabledDiscoveryTasksFieldValues
> = {
  render: ({ form }) => <DisabledDiscoveryTasks form={form} />,

  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.disabledDiscoveryTasks =
      model.discoveryTasks?.map((row) => ({
        family: row.family ?? '',
        id: row.id ?? generateGuid(),
        label: row.label ?? '',
        model: row.model ?? '',
        platform: row.platform ?? '',
        taskId: row.taskId ?? '',
        vendor: row.vendor ?? '',
        version: row.version ?? '',
        sn: row.sn ?? '',
      })) ?? [];
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.discoveryTasks =
      transformedValues.disabledDiscoveryTasks?.map((row) => ({
        id: row.id,
        family: emptyStrToNull(row.family),
        label: row.label,
        model: emptyStrToNull(row.model),
        platform: emptyStrToNull(row.platform),
        taskId: row.taskId,
        vendor: emptyStrToNull(row.vendor),
        version: emptyStrToNull(row.version),
        sn: emptyStrToNull(row.sn),
      })) ?? [];
  },
  schema: z.object({
    disabledDiscoveryTasks: z.array(discoveryTasksRowDataSchema),
  }) as z.Schema<DisabledDiscoveryTasksFieldValues>,
};
